// src\core\config\theme-component-loader.ts
import type { ComponentType } from 'react';

import { getCurrentTheme, getFallbackTheme } from './theme-config';

export function loadThemeComponent<T = any>(
  componentName: string
): ComponentType<T> {
  const themesToTry = [
    ...new Set([getCurrentTheme(), getFallbackTheme(), 'default']),
  ];

  for (const theme of themesToTry) {
    try {
      return require(`@/themes/${theme}/components/${componentName}`).default;
    } catch {}
  }

  throw new Error(
    `Component "${componentName}" not found in themes: ${themesToTry.join(', ')}.`
  );
}

export function loadThemeLayout<T = any>(layoutName: string): ComponentType<T> {
  const themesToTry = [
    ...new Set([getCurrentTheme(), getFallbackTheme(), 'default']),
  ];

  for (const theme of themesToTry) {
    try {
      return require(`@/themes/${theme}/layouts/${layoutName}`).default;
    } catch {}
  }

  throw new Error(
    `Layout "${layoutName}" not found in themes: ${themesToTry.join(', ')}.`
  );
}
